_options$isOwner